<template>
	<div class="panel_shouyin">
		<div>
			<div class="tabLine">
				<div class="tabItem" :class="[curTabIndex==0?'active':'']" @click="changeTab(0)">充值活动</div>
				<div class="tabItem" :class="[curTabIndex==1?'active':'']" @click="changeTab(1)">消费活动</div>
			</div>
			<div style="padding:20px 20px 20px;">
				<div v-show="curTabIndex==0" style="display: inline-flex;width:200px;">
					<el-input v-model="search.keyword" @keyup.enter.native="clickSearch" size="small" placeholder="请输入关键字" >
						<i class="el-icon-search el-input__icon" slot="prefix"></i>
					</el-input>
				</div>
				<div v-show="curTabIndex==1" style="display: inline-flex;width:200px;">
					<el-input v-model="search1.keyword" @keyup.enter.native="clickSearch" size="small" placeholder="请输入关键字">
						<i class="el-icon-search el-input__icon" slot="prefix"></i>
					</el-input>
				</div>
				<div style="display: inline-block;margin-left: 30px;">
					<el-button type="warning" @click="clickSearch" size="small">
						搜索
					</el-button>
				</div>
			</div>
			<el-table v-show="curTabIndex==0" class="table" :data="rechargeList" :header-cell-style="{background:'#FFF8F2'}">
				<el-table-column prop="name" label="活动名称" width="300">
				</el-table-column>
				<el-table-column label="截止日期" width="200">
					<template slot-scope="scope">
						{{$public.FTime(scope.row.exprice_time)}}
					</template>
				</el-table-column>
				<el-table-column prop="remark" label="备注">
				</el-table-column>
				<el-table-column label="操作" width="100">
					<template slot-scope="scope">
						<span class="operationBtn" @click="see(scope.row)">查看</span>
					</template>
				</el-table-column>
			</el-table>
			<el-table v-show="curTabIndex==1" class="table" :data="saleList" :header-cell-style="{background:'#FFF8F2'}">
				<el-table-column prop="name" label="活动名称" width="300">
				</el-table-column>
				<el-table-column label="截止日期" width="200">
					<template slot-scope="scope">
						{{$public.FTime(scope.row.exprice_time)}}
					</template>
				</el-table-column>
				<el-table-column prop="remark" label="备注" >
				</el-table-column>
				<el-table-column label="操作" width="100">
					<template slot-scope="scope">
						<span class="operationBtn" @click="see(scope.row)">查看</span>
					</template>
				</el-table-column>
			</el-table>
			<div style="padding:20px;">
				<page v-show="curTabIndex===0" :page="page.page" :total="page.total" @change="changePage"></page>
				<page v-show="curTabIndex===1" :page="page1.page" :total="page1.total" @change="changePage1"></page>
			</div>
		</div>
		<activitySee v-if="drawerActivitySee_state" :curItem="curItem" @submit="submit_drawerActivitySee"></activitySee>
	</div>
</template>
<script>
	import page from "../../../../components/page.vue"
	import activitySee from "../drawer/activitySee.vue"
	export default {
		components:{page,activitySee},
		data(){
			return{
				search:{
					keyword:''
				},
				search1:{
					keyword:''
				},
				curTabIndex:0,
				rechargeList:[],
				saleList:[],
				page:{
					page:1,
					pageSize:10,
					total:0
				},
				page1:{
					page:1,
					pageSize:10,
					total:0,
				},
				// see
				drawerActivitySee_state:false,
				curItem:{}
			}
		},
		computed:{
			curShopId(){
				return this.$store.state.shopId;
			},
		},
		watch:{
			
		},
		mounted(){
			this.getRechargeData();
			this.getSaleData()
		},
		methods: {
			see(row){
				this.curItem=row;
				this.drawerActivitySee_state = true;
			},
			submit_drawerActivitySee(){
				this.drawerActivitySee_state = false;
			},
			// 搜索关键字
			clickSearch(){
				if(this.curTabIndex===0){
					this.page.page=1;
					this.getRechargeData()
				}else{
					this.page1.page=1;
					this.getSaleData()
				}
			},
			// 改变tab
			changeTab(index){
				this.curTabIndex=index;
			},
			// 改变分页
			changePage(a){
				this.page.page=a;
				this.getRechargeData();
			},
			changePage1(a){
				this.page1.page=a;
				this.getSaleData();
			},
			// 获取表格数据
			getRechargeData() {
				let params = {
					"page_index": this.page.page,
					"page_size": this.page.pageSize,
					"keyword": this.search.keyword,
					"status": 2,  // 状态 -1 全部 0 删除 1 未进行 2 进行中 3 已结束 4 已停用
					"start_time": "",
					"exprice_time": "",
					"activity_model": 2,  // 线上线下 -1 不限 0 全部 1：线上；2：线下
					"activity_user": -1,  // 用户类型-1 不限 0：全部；1：普通；2：会员
					"auto_matching": -1,  // 是否自动匹配 -1 全部 1 是 2否
					"staff_type": "",  // 员工身份 1在职员工 2离职员工 空是全部 可多选
					"vipCardUser": null,  // 会员等级
					"pay_type": "",  // 支付方式集合
					"activity_type": 1,  // 活动类型 -1 全部（1：充值；2：消费；）
					"shop_id": this.curShopId,
					"new_member": -1,   // 是否新人专享 -1 全部 1 是 2否
				}
				let loading = this.$loading()
				this.$http.post(process.env.VUE_APP_Url6+'api/Activity/GetList', params).then(res => {
					loading.close();
					if (res.code == 0) {
						this.rechargeList = res.data.data;
						this.page.total = res.data.count;
					}
				})
			},
			// 获取表格数据
			getSaleData() {
				let params = {
					"page_index": this.page1.page,
					"page_size": this.page1.pageSize,
					"keyword": this.search1.keyword,
					"status": 2,  // 状态 -1 全部 0 删除 1 未进行 2 进行中 3 已结束 4 已停用
					"start_time": "",
					"exprice_time": "",
					"activity_model": 2,  // 线上线下 -1 不限 0 全部 1：线上；2：线下
					"activity_user": -1,  // 用户类型-1 不限 0：全部；1：普通；2：会员
					"auto_matching": -1,  // 是否自动匹配 -1 全部 1 是 2否
					"staff_type": "",  // 员工身份 1在职员工 2离职员工 空是全部 可多选
					"vipCardUser": null,  // 会员等级
					"pay_type": "",  // 支付方式集合
					"activity_type": 2,  // 活动类型 -1 全部（1：充值；2：消费；）
					"shop_id": this.curShopId,
					"new_member": -1,   // 是否新人专享 -1 全部 1 是 2否
				}
				let loading = this.$loading()
				this.$http.post(process.env.VUE_APP_Url6+'api/Activity/GetList', params).then(res => {
					loading.close();
					if (res.code == 0) {
						this.saleList = res.data.data;
						this.page1.total = res.data.count;
					}
				})
			},
		},
	}
</script>
<style scoped lang="scss">
.panel_shouyin{
	background-color: #fff;height: 100%;overflow: auto;padding:0 0 20px;box-sizing: border-box;
	.tabLine{
		display: flex;
		padding:30px 30px 0px;
		border-bottom:1px solid #F2F2F2;
		.tabItem{
			margin-right: 40px;
			padding:0 2px 20px;
			font-size: 16px;
			cursor: pointer;
			color:$fontColor;
			&.active{
				color:$mainColor;
				font-weight: bold;
				border-bottom:3px solid $mainColor;
			}
		}
	}
	.operationBtn{
		color:$mainColor;cursor: pointer;
	}
}
</style>
